export const capitalizar = (palabra) => {
    return palabra.slice(0, 1).toUpperCase() + palabra.slice(1);
};
